<div class="db-advanced-settings">
  <div class="db-advanced-settings-get-options">
    <div class="ds-input-wrap">
      <div class="ds-textarea-label-wrap">
        <span class="ds-input-label">Get Options Data</span>
      </div>
      <textarea type="text" class="ds-textarea db-get-response" [value]="(advancedOptionsGet | json) || ''"></textarea>
    </div>
    <button class="ds-btn ds-btn-l ds-btn-blue" [disabled]="loading" (click)="getAdvancedOptions()">
      <span *ngIf="!loading">Get Data</span>
      <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
    </button>
  </div>
  <div class="db-advanced-settings-set-options">
    <div class="db-advanced-settings-set-options-key">
      <div class="ds-input-wrap">
        <span class="ds-input-label">Key</span>
        <input type="text" class="ds-input" placeholder="Key" [formControl]="setOptionKey">
      </div>
    </div>
    <div class="db-advanced-settings-set-options-value">
      <div class="ds-input-wrap">
        <span class="ds-input-label">Value</span>
        <input type="text" class="ds-input" placeholder="Value" [formControl]="setOptionValue">
      </div>
    </div>
    <div class="db-advanced-settings-options-response">
      <div class="ds-input-wrap">
        <div class="ds-textarea-label-wrap">
          <span class="ds-input-label">Response Data</span>
        </div>
        <textarea type="text" class="ds-textarea" [value]="(advancedOptionsSet | json) || ''"></textarea>
      </div>
    </div>
    <button class="ds-btn ds-btn-l ds-btn-blue" [disabled]="loading" (click)="setAdvancedOptions()">
      <span *ngIf="!loading">Save</span>
      <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
    </button>
  </div>
  <div class="db-advanced-settings-get-options">
  <div class="ds-input-wrap">
    <div class="ds-textarea-label-wrap">
      <span class="ds-input-label">Get Initial Mode Data</span>
    </div>
    <textarea type="text" class="ds-textarea db-get-response" [value]="(initialModeGet | json) || ''"></textarea>
  </div>
  <button class="ds-btn ds-btn-l ds-btn-blue" [disabled]="loading" (click)="getInitialMode()">
    <span *ngIf="!loading">Get Data</span>
    <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
  </button>
</div>
</div>
